import { render, staticRenderFns } from "./SortBy.vue?vue&type=template&id=9aad8a44&scoped=true"
import script from "./SortBy.vue?vue&type=script&lang=js"
export * from "./SortBy.vue?vue&type=script&lang=js"
import style0 from "./SortBy.vue?vue&type=style&index=0&id=9aad8a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aad8a44",
  null
  
)

export default component.exports